import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Card, Col, Row, Nav } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import StudentInfoForm from "../students/StudentInfoForm";

export default function StudentInfo() {
  const { studentID } = useParams();
  ///// Skin Switch /////
  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');
      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-white');
      }
    }

    // Toggle dark mode for all tables
    const tables = document.getElementsByTagName('table');
    for (const table of tables) {
      const theads = table.querySelectorAll('thead'); // หาทุก thead ภายใน table
      if (skin === 'dark') {
        for (const thead of theads) {
          thead.classList.remove('table-secondary');
          thead.classList.add('table-primary');
        }
        table.classList.add('table-dark');
      } else {
        table.classList.remove('table-dark');
        for (const thead of theads) {
          thead.classList.remove('table-primary');
          thead.classList.add('table-secondary');
        }
      }
    }
  }

  switchSkin(skin);

  useEffect(() => {
    switchSkin(skin);
  }, [skin])

  return (
      <React.Fragment>
        <Header onSkin={setSkin} />
        <div className="main main-app p-3 p-lg-4">
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <div>
              <ol className="breadcrumb fs-sm mb-1">
                <li className="breadcrumb-item">
                  <Link to="#">ข้อมูลประจำชั้น</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">ข้อมูลนักเรียนทั้งหมดในห้องเรียน</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  แสดงข้อมูลนักเรียน
                </li>
              </ol>
              <h4 className="main-title mb-0">แสดงข้อมูลนักเรียน</h4>
            </div>
          </div>
          <Row className="g-12 mb-4">
            <Col xl="12">
              <Card className="card-one">
                <Card.Header>
                  <Card.Title as="h6">ข้อมูลประวัติส่วนตัวนักเรียน</Card.Title>
                  <Nav className="nav-icon nav-icon-sm ms-auto">
                    <Nav.Link href=""><i className="ri-refresh-line"></i></Nav.Link>
                    <Nav.Link href=""><i className="ri-more-2-fill"></i></Nav.Link>
                  </Nav>
                </Card.Header>
                <Card.Body className="p-3">
                  <StudentInfoForm studentID={studentID} />
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Footer />
        </div>
      </React.Fragment>
    )
  }
